import React from "react";
import { styled } from "@mui/material/styles";

const Root = styled('div')(({ theme }) => ({
  backgroundColor: "#000", // or custom bg if needed
  padding: theme.spacing(2),
  textAlign: 'center',
}));

export default function Footer() {
  return (
    <Root>
      <p style={{ color: '#FFF', marginBottom: 0 }}>
        Copyright © TehDrink | Innovatio
      </p>
    </Root>
  );
}